import React from 'react';
import Parse from 'parse';
import {Timeline} from 'react-event-timeline';
import AppointmentCard from './../../Components/Presentation/AppointmentCard/AppointmentCard';
import AddAppointment from '../../Components/Presentation/AddAppointment/AddAppointment';
import EmptyState from '../../Components/Presentation/EmptyState/EmptyState';


class HistoryAppointment extends React.Component {
    constructor(){
        super();
        this.state = {
            appointments:{}
        }
    }
    
    componentDidMount = () => {
        this.setState({patient: this.props.patient});
        this.updateQuestionsWithPatientData(this.props.patient);
    }

    updateQuestionsWithPatientData = (patient) => {
        if(patient === null || patient.id === 0){
          return;
        }
        this.setState({
            appointments: patient.get("appointments")
        });
    }

    deleteAppointment = async (appointment) => {
        let {patient} = this.props;
        const Patient = Parse.Object.extend('Patient');
        const query = new Parse.Query(Patient);
        patient = await query.get(patient.id); 
        let appointments = patient.get("appointments");
        delete appointments[appointment.id];
        patient.set("appointments", appointments);
        patient.save();
        
        this.setState({
            appointments: appointments,
            date: new Date(),
            hour: null,
            minute: null,
            notes:null,
        });
    }

    editAppointment = async (appointment) => {
        let {patient} = this.props;
        const Patient = Parse.Object.extend('Patient');
        const query = new Parse.Query(Patient);
        patient = await query.get(patient.id); 
        let appointments = patient.get("appointments");
        appointments[appointment.id]= {id: appointment.id, date: appointment.date, hour: appointment.hour, minute: appointment.minute, notes: appointment.notes};
        patient.set("appointments", appointments);
        patient.save();
        
        this.setState({
            appointments: appointments,
        });
    }

    onSave = async (newAppointment) => {
        

        let {patient} = this.props;
        const Patient = Parse.Object.extend('Patient');
        const query = new Parse.Query(Patient);
        patient = await query.get(patient.id); 
        let appointments = patient.get("appointments");
        if(typeof appointments === "undefined"){
            appointments= {};
        }
        const id = this.makeid(5);
        appointments[id]= {
            id: id, 
            date: newAppointment.date, 
            hour: newAppointment.hour, 
            minute: newAppointment.minute, 
            notes: newAppointment.notes};

        patient.set("appointments", appointments);
        patient.save();
        this.setState({
            appointments: appointments,
            date: new Date(),
            hour: null,
            minute: null,
            notes:null,
        });
    }

    makeid = (length) =>{
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    render() {
        const {patient} = this.props;
        let {appointments} = this.state;

        if(patient === null){
            return <p>cargando...</p>
        }

        if(typeof appointments === "undefined"){
            appointments = null;
        }

        if(appointments === null || Object.keys(appointments).length === 0){
            return (
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <AddAppointment
                                onSave={this.onSave}
                            />
                            <EmptyState
                                title="Agrega citas con el botón (+)"
                            />
                        </div>
                    </div>
                </div>
            )
        }

        let appointmentsList = [];
        //ordenar por fecha
        let sortedAppointments = [];
        for(var appointment in appointments){
            sortedAppointments.push([appointment, appointments[appointment].date]);
        }

        sortedAppointments.sort(function(a, b) {
            return new Date(b[1]) - new Date(a[1])
        });

        console.log(sortedAppointments, "ordenados");


        sortedAppointments.forEach((appointment) => {
            appointmentsList.push(
                <AppointmentCard
                    appointment={appointments[appointment[0]]}
                    editHandler={this.editAppointment}
                    deleteHandler={this.deleteAppointment}
                />
            )
        });
        
        return(
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <AddAppointment
                            onSave={this.onSave}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Timeline
                            lineColor="#ABD1F9"
                        >
                            {appointmentsList}
                        </Timeline>
                    </div>
                </div>
            </div>
        )
    }

  
}

export default HistoryAppointment;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/HistoryAppointment.js